import React from "react";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";

const SegmentedButtonGroup = ({ data = [], value, handleChange }) => {
  const propControl = (item) => ({ inputProps: { "aria-label": item } });
  return (
    <>
      <FormControl style={{ width: "100%" }}>
        <RadioGroup
          style={{ width: "100%", display: "flex" }}
          row
          aria-labelledby={"radio-group-horizontal"}
          name={"radio-group-horizontal"}
          value={value}
          onChange={(e) => {
            handleChange(e.target.value);
          }}
        >
          {data.map((item, idx) => (
            <FormControlLabel
              value={item.value}
              key={idx}
              sx={{
                m: 0,
                height: "21px",
                flex: 1,
                display: "flex",
                justifyContent: "center",
                padding: "4px",
                ...(item.value === value && {
                  backgroundColor: "#007842",
                  color: "white",
                }),
                borderRadius: `${
                  idx === 0 && idx === data.length - 1
                    ? "12px 12px 12px 12px"
                    : idx === 0
                    ? "12px 0px 0px 12px"
                    : idx === data.length - 1 && "0px 12px 12px 0px"
                }`,
                border: "1px solid rgba(0, 120, 66, 0.5)",
                ".MuiFormControlLabel-label": {
                  fontSize: 13,
                  lineHeight: "4em",
                },
              }}
              control={
                <Radio
                  {...propControl({ label: item.label })}
                  sx={{
                    display: "none",
                  }}
                />
              }
              label={
                <div
                  style={{
                    height: "14px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      fontSize: "10px",
                      maxWidth: "50px",
                    }}
                  >
                    {item.label}
                  </span>
                </div>
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );
};

export default SegmentedButtonGroup;
